import { faSquareCheck } from '@fortawesome/free-regular-svg-icons'
import type { FC } from 'react'
import React from 'react'

import ActionButton from './ActionButton'

interface Props {
  onClick: () => void
  disabled?: boolean
}

const VerifyButton: FC<Props> = ({ onClick, disabled = false }) => (
  <ActionButton
    label="Verify"
    icon={faSquareCheck}
    onClick={onClick}
    disabled={disabled}
  />
)

export default VerifyButton
